export default "__VITE_ASSET__DreLWHE4__"